// Copyright (c) 2020 JCA Electronics , Winnipeg, MB. All rights reserved.

import VueI18n from './i18n';

export function addressRequired(): (data: string) => void {
  return (v) => !!v || 'Address is required';
}
export function addressValid(): (data: string) => void {
  return (v) => /http.?:\/\/.+/.test(v) || 'Address must be valid';
}
export function pathNameValid(): (data: string) => void {
  return (v) => !!v || VueI18n.t('field_required');
}
export function pathNameMaxLength(): (data: string) => void {
  return (v) => (v && v.length < 20) || 'Max length 20 characters';
}
